import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import beforeHandler from './beforeHandler';
import afterHandler from './afterHandler';

Vue.use(VueRouter);

// Initialize the router
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: routes.map(route => {
		return route.register();
	})
});

// Attach middleware handlers to router
router.beforeEach(beforeHandler);
router.afterEach(afterHandler);

export default router;
